export default {"src":"/_next/static/media/OrbPinkLarge.fc2b2bcb.svg","height":91,"width":91,"blurWidth":0,"blurHeight":0};